<template>
    <header class="main-header"  style="background-color: black;">
        <!-- Logo -->
        <router-link to="/" class="logo">
            <!-- mini logo for sidebar mini 50x50 pixels --><span class="logo-mini"><b><img src="static/img/REKFIXLOGOSMALL.png" alt="User Image"></b></span>
            <!-- logo for regular state and mobile devices --><span class="logo-lg" style="height:1px"><b><img src="static/img/REKFIXLOGOSMALL.png" alt="User Image"></b></span> </router-link>
        <!-- Header Navbar: style can be found in header.less -->
        <nav class="navbar navbar-static-top">
            <!-- Sidebar toggle button-->
            <a id="main-sidebar" href="#" class="sidebar-toggle" data-toggle="offcanvas" 
  data-target="collapse"
 role="button" @click="handleToggle()"> <span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </a>
                                <div class="pull-left-search">
                                    
                        <form id="demo-2">
                             
	<input class="devin-search" type="search">
    

</form>
    
    
    </div>
            <div id="Custom-menu" class="navbar-custom-menu">
                <ul class="nav navbar-nav">
                    <!-- Messages: style can be found in dropdown.less-->

                    <li>
                        <el-dropdown class="header-dropdown-devin" trigger="click"> <span class="el-dropdown-link">
                            <!--el-badge :value="20" :max="9" class="item">
                            <el-button type="text" size="small"><i class="ti-email"></i></el-button>
                          </el-badge-->
                         <router-link to="/">
                           <el-button type="text" size="small" ><i class="ti-home" style="color:blue;"> <b style="padding:4px; color:blue;">Home</b></i></el-button>
                           </router-link>
                          </span>
                            
                        </el-dropdown>
                    </li>
                    <li>
                        <el-dropdown class="header-dropdown-devin" trigger="click"> <span class="el-dropdown-link">
                            <!--el-badge :value="20" :max="9" class="item">
                            <el-button type="text" size="small"><i class="ti-email"></i></el-button>
                          </el-badge-->
                           <el-button type="text" size="small"><i class="ti-email"></i></el-button>
                          </span>
                            <el-dropdown-menu slot="dropdown">
                                <ul class="dropdown-menu-devin">
                                    <li class="header">You have no new Messages</li>
                                    <!-- inner menu: contains the actual data -->
                                    <!--li>
                                        <ul class="menu">
                                            <li>
                                                <a href="#">
                                                    <h3>Announcements <span>Just Now !</span>
                                                        </h3>
                                                    <p>Pok ame ame belalang kupu kupu</p>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <h3>Complete your profile<span>2 Min Ago</span>
                                                        </h3>
                                                    <p>Siang makan nasi kalo malam minum susu</p>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <h3>New Schedule Realease<span>30 Min ago</span>
                                                        </h3>
                                                    <p>Bintang kecil dilangit yang tinggi</p>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <h3>New Student Data<span>1 Hour ago</span>
                                                        </h3>
                                                    <p>Amat banyak menghias angkasa</p>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <h3>Graduate Student List<span>2 Days ago</span>
                                                        </h3>
                                                    <p>Aku ingin terbang dan melayang, jauh tinggi ke tempat kau berada</p>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li class="footer"><a href="#">View all</a></li-->
                                </ul>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </li>
                    <!-- Notifications: style can be found in dropdown.less -->
                    <li>
                        <el-dropdown class="header-dropdown-devin" trigger="click"> <span class="el-dropdown-link">
                            <!--el-badge is-dot class="item ">
                            <el-button type="text" size="small"><i class="ti-bell"></i></el-button>
                          </el-badge-->
                                                      <el-button type="text" size="small"><i class="ti-bell"></i></el-button>

                          </span>
                            <el-dropdown-menu slot="dropdown">
                                <ul class="dropdown-menu-devin">
                                    <li class="header">You have no new notifications</li>
                                </ul>
                                <!--ul class="dropdown-menu-devin">
                                    <li class="header">You have 10 notifications</li>
                                    <li>
                                        < inner menu: contains the actual data >
                                        <ul class="menu">
                                            <li> <i class="ti-announcement"></i>
                                                <a href="#">
                                                    <h3>Announcements <span class="text-green fontello-record"></span>
                                                        </h3>
                                                    <p>Just Now !</p>
                                                </a>
                                            </li>
                                            <li> <i class="ti-user"></i>
                                                <a href="#">
                                                    <h3>Complete your profile<span class="text-yellow fontello-record"></span>
                                                        </h3>
                                                    <p>2 Min Ago</p>
                                                </a>
                                            </li>
                                            <li> <i class="ti-notepad"></i>
                                                <a href="#">
                                                    <h3>New Schedule Realease<span class="text-yellow fontello-record"></span>
                                                        </h3>
                                                    <p>30 Min ago</p>
                                                </a>
                                            </li>
                                            <li> <i class="ti-agenda"></i>
                                                <a href="#">
                                                    <h3>New User Data<span class="text-orange fontello-record"></span>
                                                        </h3>
                                                    <p>1 Hour ago</p>
                                                </a>
                                            </li>
                                            <li> <i class="ti-package"></i>
                                                <a href="#">
                                                    <h3>New User List<span class="fontello-record"></span>
                                                        </h3>
                                                    <p>2 Days ago</p>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li class="footer"><a href="#">View all</a></li>
                                </ul-->
                            </el-dropdown-menu>
                        </el-dropdown>
                    </li>
                    <!-- Control Sidebar Toggle Button -->
                    <li>
                        <el-dropdown class="header-dropdown-devin" trigger="click"> <span class="el-dropdown-link">
                            
                            <!--el-button data-toggle="control-sidebar" data-dismiss="control-sidebar" type="text" size="small"><i class="dripicons-swap"></i></el-button-->
                          
                          </span> </el-dropdown>
                    </li>
                  
                </ul>
            </div>
        </nav>
    </header>
</template>
<script>
  export default {
    name: 'DashboardHeader',
    mounted: function () {
         console.log("something", $('body').hasClass('sidebar-open'))
        //console.log("element", document.getElementById("main-sidebar").dismiss())
//         const triggers = Array.from(document.querySelectorAll('[data-toggle="collapse"]'));

// window.addEventListener('click', (ev) => {
//   const elm = ev.target;
//   if (triggers.includes(elm)) {
//     const selector = elm.getAttribute('data-target');
//     this.collapse(selector, 'toggle');
//   }
// }, false);
    },
    data(){
        return {
            offcanvas: true,
            show: true
        }
    },
    watch:{
    $route (to, from){
        const width = window.innerWidth //get screen width
        //for phones
        if (width <= 500){
            this.togglingHandlerPhone(to)
        }
        else if (width > 500){
            this.togglingHandler(to)
        }
    }
} ,
    methods:{
        handleToggle: function(){
                        console.log("width", window.innerWidth)

               const hasCollapse = $('body').hasClass('sidebar-collapse')
                const hasOpen = $('body').hasClass('sidebar-open')

            const width = window.innerWidth //get screen width

        //for phones
        // if (width <= 500){
        //     this.setScrollDivPhone(hasOpen)
        // }
        if (width > 500){
            this.setScrollDiv(hasCollapse)
        }

            

        },
        dismissId: function(){
             console.log("HERE!")
// Handler that uses various data-* attributes to trigger
// specific actions, mimicing bootstraps attributes
let elm = document.getElementById("main-sidebar")
             console.log("HERE!", elm)
this.eventFire(elm, 'click');

//  const selector = elm.getAttribute('data-target');
//     this.collapse(selector, 'toggle');



},
setScrollDivPhone: function(hasOpen){
        console.log(hasOpen)
        //solution for now. Since the hasCollapse state changes AFTER this functon invocation, we have to check for a Falsy value, event though the value will be
        //Truthy after this function returns
        //TODO: this is a very hacky soln. need to find more stable formal soln to change slim scroll size on collpase
                    if(hasOpen){
              var w=50;
      $('#scrollDiv').width(w);
      $('.slimScrollDiv').width(w);
                    }
   
   if(!hasOpen){
              var w=230;
      $('#scrollDiv').width(w);
      $('.slimScrollDiv').width(w);
                    }

                    this.$nextTick(() => {
    // The whole view is rendered, so I can safely access or query
    // the DOM. ¯\_(ツ)_/¯
    console.log("nextTick",  $('body').hasClass('sidebar-open'), hasOpen)
  })
},
setScrollDiv: function(hasCollapse){
            console.log(hasCollapse)

        //solution for now. Since the hasCollapse state changes AFTER this functon invocation, we have to check for a Falsy value, even though the value will be
        //Truthy after this function returns
        //TODO: this is a very hacky soln. need to find more stable formal soln to change slim scroll size on collpase
                

                                      this.$nextTick(() => {
                                          
    // The whole view is rendered, so I can safely access or query
    // the DOM. ¯\_(ツ)_/¯
        if(!hasCollapse){
              var w=50;
      $('#scrollDiv').width(w);
      $('.slimScrollDiv').width(w);
                    }
   
   if(hasCollapse){
              var w=230;
      $('#scrollDiv').width(w);
      $('.slimScrollDiv').width(w);
                    }
  })
},
togglingHandler: function(routeTo){
   const hasCollapse = $('body').hasClass('sidebar-collapse')
        console.log("route", routeTo)
        if(routeTo.name === "dashboard"){
                    console.log("showed dashboard",hasCollapse)

            //$('#collapse').trigger("offcanvas.toggle");
            if(hasCollapse){
                this.dismissId()
                
            }
            
        }
        //$('collapse').trigger("offcanvas.toggle");
        else{
        console.log("showed",hasCollapse)
        if(!hasCollapse){
        this.dismissId()
        }
}
},
togglingHandlerPhone: function(routeTo){
        const hasOpen = $('body').hasClass('sidebar-open')
        console.log("route", routeTo)
        if(routeTo.name === "dashboard"){
                    console.log("showed dashboard",hasOpen)

            //$('#collapse').trigger("offcanvas.toggle");
            if(!hasOpen){
                this.dismissId()
                
            }
            
        }
        //$('collapse').trigger("offcanvas.toggle");
        else{
        console.log("showed",hasOpen)
        if(hasOpen){
        this.dismissId()
        }
}
},
 eventFire: function(el, etype){
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
},
collapse: function(selector, cmd){
                 console.log("sel!", selector)

    const fnmap = {
  'toggle': 'toggle',
  'show': 'add',
  'hide': 'remove'
};
  const targets = Array.from(document.querySelectorAll("[data-target=\"" + selector + "\"]"));
  console.log(targets)
  targets.forEach(target => {
    target.classList[fnmap[cmd]]('toggle');
  });
        },
        
    }
  }
</script>


// WEBPACK FOOTER //
// Header.vue?0e05d28e